import { render, staticRenderFns } from "@/manager/budget/views/budget-row/budget-row.pug?vue&type=template&id=45c8a5ed&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/manager/budget/views/budget-row/budget-row.scss?vue&type=style&index=0&id=45c8a5ed&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c8a5ed",
  null
  
)

export default component.exports